import axios from "axios";
import {
  SETTINGS_PUNCH_LIST_TYPE_CLEAR_SNACKBAR,
  SETTINGS_PUNCH_LIST_TYPE_ERROR,
  SETTINGS_DELETE_PUNCH_LIST_TYPE_SUCCESS,
  SETTINGS_GET_PUNCH_LIST_TYPE_LOADING,
  SETTINGS_ADD_PUNCH_LIST_TYPE_SUCCESS,
  SETTINGS_ADD_PUNCH_LIST_TYPE_ERROR,
  SETTINGS_GET_PUNCH_LIST_TYPE,
  SETTINGS_ADD_PUNCH_LIST_TYPE,
} from "../constants/types";
import queryString from "query-string";

// import { bulkUploadFiles } from "./documentsActions";

import { server_url } from "../constants/types";
import request from "config/api";

export const fetchPunchListType = (params = {}) => {
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: SETTINGS_GET_PUNCH_LIST_TYPE_LOADING,
        payload: {
          loading: true,
        },
      });
      const newParams = {
        PageNumber: params.page ? params.page + 1 : 1,
        PageSize: params.pageSize ? params.pageSize : 10,
      };
      const queryParams = queryString.stringify(newParams);

      request({
        url: `${server_url}/PunchListType`,
        method: "GET",
      })
        .then((response) => {
          dispatch({
            type: SETTINGS_GET_PUNCH_LIST_TYPE,
            payload: {
              punchListType: response.data,
              totalCount: response.data.length,
              loading: false,
            },
          });
          resolve();
        })
        .catch((e) => {
          dispatch({
            type: SETTINGS_PUNCH_LIST_TYPE_ERROR,
            payload: {
              status: "error",
              text: "Error occured during getting all PunchListType.",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        });
    });
  };
};

export const addUpdatePunchListType = ({ formData, onSuccess, payload }) => {
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: SETTINGS_ADD_PUNCH_LIST_TYPE,
        payload: {
          loading: true,
        },
      });

      let data = {
        ...formData,
      };

      request({
        method: formData.punchListTypeId ? "PUT" : "POST",
        url: `${server_url}/PunchListType${
          formData.punchListTypeId ? `/${formData.punchListTypeId}` : ""
        }`,
        body: { ...data, listingOrder: data.listingOrder + 1 },
      })
        .then(async (response) => {
          onSuccess();

          dispatch({
            type: SETTINGS_ADD_PUNCH_LIST_TYPE_SUCCESS,
            payload: {
              response: response.data,
              status: "success",
              text: formData.punchListTypeId
                ? "PunchListType updated Successfully"
                : "PunchListType Created Successfully",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        })
        .catch((e) => {
          dispatch({
            type: SETTINGS_ADD_PUNCH_LIST_TYPE_ERROR,
            payload: {
              text: "Error occurred during creating punchListType data.",
              status: "error",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        });
    });
  };
};

export const punchListTypeDelete = ({
  punchListTypeId,
  pageModel,
  onSuccess = () => {},
  showSnackbar = true,
}) => {
  console.log("Check the punchListTypeDelete Action", punchListTypeId);
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: SETTINGS_GET_PUNCH_LIST_TYPE_LOADING,
        payload: {
          loading: true,
        },
      });
      request({
        url: `${server_url}/PunchListType/${punchListTypeId}`,
        method: "DELETE",
      })
        .then((response) => {
          dispatch(fetchPunchListType({ ...pageModel }));
          onSuccess();

          dispatch({
            type: SETTINGS_DELETE_PUNCH_LIST_TYPE_SUCCESS,
            payload: {
              response: response.data,
              status: "success",
              text: "punchListType Deleted Successfully",
              loading: false,
              showSnackbar: true,
            },
          });

          resolve();
        })
        .catch((e) => {
          dispatch({
            type: SETTINGS_PUNCH_LIST_TYPE_ERROR,
            payload: {
              text: "Error occurred during deleting punchListType data.",
              status: "error",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        });
    });
  };
};

export const punchListTypeClearShowSnackbar = () => {
  return (dispatch, getState) => {
    dispatch({
      type: SETTINGS_PUNCH_LIST_TYPE_CLEAR_SNACKBAR,
    });
  };
};
